/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { UpdateManualEntryMutationRequest, UpdateManualEntryMutationResponse, UpdateManualEntryPathParams, UpdateManualEntry400, UpdateManualEntry401, UpdateManualEntry403, UpdateManualEntry404, UpdateManualEntry409, UpdateManualEntry500 } from "../../types/financialHubController/UpdateManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateManualEntry } from "../../client/financialHubController/updateManualEntry.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateManualEntryMutationKey = () => [{ url: '/api/organizations/:organizationId/financial/transactions/:transactionId' }] as const

export type UpdateManualEntryMutationKey = ReturnType<typeof updateManualEntryMutationKey>

export function updateManualEntryMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateManualEntryMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateManualEntryMutationKey()
        return mutationOptions<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, {organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, transactionId, data }) => {
            return updateManualEntry(organizationId, transactionId, data, config)
          },
        })

}

/**
 * @summary Update a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/:transactionId}
 */
export function useUpdateManualEntry<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, {organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateManualEntryMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateManualEntryMutationKey()

          const baseOptions = updateManualEntryMutationOptions(config) as UseMutationOptions<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, {organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest}, TContext>
          

          return useMutation<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, {organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateManualEntryMutationResponse, ResponseErrorConfig<UpdateManualEntry400 | UpdateManualEntry401 | UpdateManualEntry403 | UpdateManualEntry404 | UpdateManualEntry409 | UpdateManualEntry500>, {organizationId: UpdateManualEntryPathParams["organizationId"], transactionId: UpdateManualEntryPathParams["transactionId"], data: UpdateManualEntryMutationRequest}, TContext>
      
}